export default __webpack_public_path__ + "static/media/efil.69877d91.jpg";